module.exports = __webpack_public_path__ + "img/客户logo_2.092d482b.png";